var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBirth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4698_916)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    y: 0.5,
    width: 48,
    height: 48,
    fill: "#0F90FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8173 17.7166C25.4352 17.7166 26.7469 16.3478 26.7469 14.6592C26.7469 12.9707 24.0004 9.5 23.8173 9.5C23.6342 9.5 20.8877 12.9707 20.8877 14.6592C20.8877 16.3478 22.1993 17.7166 23.8173 17.7166ZM21.2535 20.0095C20.8491 20.0095 20.5211 20.3517 20.5211 20.7738V24.5955L14.9588 24.6028L14.8894 24.6083C12.713 24.7811 11 26.676 11 28.9904C11 29.9122 11.2718 30.7678 11.7367 31.4745H11.7324V37.2069C11.7324 38.4733 12.7162 39.4999 13.9296 39.4999H33.7042C34.9176 39.4999 35.9014 38.4733 35.9014 37.2069V31.9507C36.5837 31.1696 37 30.1307 37 28.9904C37 26.676 35.287 24.7811 33.1106 24.6083L33.0434 24.6029L29.8631 24.5955H27.1127V20.7738C27.1127 20.3517 26.7847 20.0095 26.3803 20.0095H21.2535ZM18.7813 31.3215C19.0385 31.4204 19.316 31.4745 19.6056 31.4745C19.7433 31.4745 19.8785 31.4622 20.0097 31.4388C20.1546 31.413 20.2951 31.3734 20.4299 31.3215C21.05 31.0826 21.5489 30.5818 21.8028 29.9475C22.0567 30.5818 22.5556 31.0826 23.1757 31.3215C23.4328 31.4204 23.7103 31.4745 24 31.4745C24.1252 31.4745 24.2478 31.4644 24.3676 31.445C24.4438 31.4327 24.5189 31.4165 24.5926 31.3968C24.6212 31.3893 24.6494 31.3812 24.6773 31.3725C24.727 31.3571 24.776 31.3401 24.8243 31.3215C25.4444 31.0826 25.9433 30.5818 26.1972 29.9475C26.4511 30.5818 26.95 31.0826 27.5701 31.3215C27.8272 31.4204 28.1047 31.4745 28.3944 31.4745C28.684 31.4745 28.9615 31.4204 29.2187 31.3215C29.8388 31.0826 30.3376 30.5818 30.5915 29.9475C30.8455 30.5818 31.3443 31.0826 31.9644 31.3215C32.2216 31.4204 32.4991 31.4745 32.7887 31.4745C34.1033 31.4745 35.169 30.3623 35.169 28.9904C35.169 27.6828 34.201 26.6112 32.9718 26.5136L29.8592 26.5063L15.0282 26.5136C13.799 26.6112 12.831 27.6828 12.831 28.9904C12.831 30.3623 13.8967 31.4745 15.2113 31.4745C15.3468 31.4745 15.4798 31.4626 15.6093 31.4399C15.7563 31.4141 15.899 31.3742 16.0356 31.3215C16.6557 31.0826 17.1545 30.5818 17.4085 29.9475C17.6624 30.5818 18.1612 31.0826 18.7813 31.3215Z",
    fill: "#0F90FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4698_916"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 48,
    height: 48,
    rx: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirth);
export default __webpack_public_path__ + "static/media/birth.3f7612347c14fc5a46fa8f70d5a4c02c.svg";
export { ForwardRef as ReactComponent };